<template>
    <div v-if="!isWeixin" class="sq-notice">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="el-icon-warning" style="color: #2b94ff;font-size:100px">
                </i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">温馨提示</h2>
                <p class="weui_msg__desc">{{notice}}</p>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="spxqy">
            <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
            </van-nav-bar>
            <div :style="{opacity: opacity}" class="nav" v-if="opacity>0">
                <div class="header-new-title">
                    <nav class="detail_anchor">
                    <span class="dhbt" type="goods" :class="{'active1': currentTab=='goods'}"
                          @click="onScrollGoods"><span>商品信息</span></span>
                        <!--                        <span class="dhbt" type="con" :class="{'active1': currentTab=='con'}"-->
                        <!--                              @click="onScrollCon"><span>内容介绍</span></span>-->
                        <span class="dhbt" type="miaoshu" :class="{'active1': currentTab=='miaoshu'}"
                              @click="onScrollMiaoshu"><span>图文详情</span></span>
                        <span class="dhbt" type="wypj" :class="{'active1': currentTab=='wypj'}"
                              @click="onScrollWypj"><span>网友评价</span></span>
                    </nav>
                </div>
            </div>
            <div style="padding-top: 50px">
                <div class="goods">
                    <div>
                        <van-swipe :autoplay="3000" :height="this.screenWidth" :width="this.screenWidth"
                                   indicator-color="white">
                            <van-swipe-item v-for="item in imgList">
                                <van-image :src="item.imgUrl"/>
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-cell custom-class="goods-express" style="padding: 3px 17px;">
                            <van-col span="10">
                                <span style="height: 20px;color: #ff4d51;font-size: 18px">¥{{sku.sellingPrice}}</span>
                                <span class="jg-span">{{sku.costPrice}}</span>
                            </van-col>
                            <van-col span="14" style="text-align: right;font-size: 10px;color: #888888">
                                已售 {{spu.salesVolume}}
                            </van-col>
                        </van-cell>
                        <van-cell
                                custom-class="goods-message"
                                :title="spu.spuName"
                                :label="spu.introduce"
                                style="padding: 3px 17px;margin-top: -8px;"
                        >
                        </van-cell>
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-cell  is-link :border="false">
                            <div is-link @click="toSpec('GM')">
                                <span style="font-size: 12px;display: block;" v-if="sku.specs">{{sku.specs}}</span>
                                <span style="font-size: 12px;display: block;" v-else>选择规格</span>
                            </div>
                        </van-cell>
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-cell icon="shop-o" is-link >
                            <span style="font-size: 12px">查看可用门店</span>
                        </van-cell>
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-coupon-cell
                                icon="coupon-o"
                                :coupons="coupons"
                                :chosen-coupon="chosenCoupon"
                                @click="showList = true"
                                style="font-size: 12px"
                        />
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-cell :border="false">
                            <!--          <div slot="title" style="font-size: 12px" v-if="addressInfo&&addressInfo.id">-->
                            <!--            {{addressInfo.province}}{{addressInfo.city}}{{addressInfo.county}}{{addressInfo.addressDetail}}-->
                            <!--          </div>-->
                            <!--          <div slot="title" style="font-size: 12px" v-else>-->
                            <!--            配送-->
                            <!--          </div>-->
                        </van-cell>
                        <van-cell style="padding: 0px 17px 11px 17px">
                            <div style="display: flex;flex-direction: column;">
                                <span style="font-size: 12px">运费 请以提交订单时为准</span>
                                <div style="font-size: 10px;display:flex;flex-direction: row">
                                    <span style="margin-right: 10px">Θ店铺发货与售后</span>
                                    <span style="margin-right: 10px">Θ可配送全球</span>
                                    <span>Θ支持未发货退单</span>
                                </div>
                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class="miaoshu" ref="miaoshu" id="miaoshu">
                    <div style="width: 95%;margin:auto;">
                    <p v-html="spu.description"></p>
                    </div>
                </div>
                <div class="wypj" ref="wypj">
                    <span style="font-size: 13px;display: block;text-align: center">暂无评价</span>
                </div>
            </div>
        </div>
        <div>
            <van-goods-action>
                <van-goods-action-icon icon="chat-o" text="客服" @click="onClickIcon"/>
                <van-goods-action-icon icon="cart-o" text="购物车" @click="toCart"/>
                <!--        @click="addCart"-->
                <van-goods-action-button type="warning" text="加入购物车" @click="toSpec('GWC')"/>
                <van-goods-action-button type="danger" text="立即购买" @click="toSpec('GM')"/>
            </van-goods-action>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay round
                   style="height: 66%;">
            <div class="specs">
                <div class="sku-info">
                    <img :src="spu.coverImg"/>
                    <div style="display: flex;flex-direction: column;justify-content: center;padding-left: 12px">
                        <span style="font-size: 13px">{{spu.spuName}}</span>
                        <span style="color: #ff4d51;font-size: 12px;margin-top:8px">¥{{sku.sellingPrice}} <span
                                class="jg-span">{{sku.costPrice}}</span></span>
                    </div>
                </div>
                <div class="sku-spec">
                    <span>规格/尺码</span>
                    <div class="spm-item">
            <span v-for="(sku,index) in skus" class="spm-item-spec" :class="{'spec-active':index==specActive}"
                  @click="checkedSpec(index,sku)">
             {{sku.specs}}
            </span>
                    </div>
                    <div style="margin-bottom: 55px;margin-top: 30px">
                        <van-cell-group custom-class="goods-cell-group">
                            <van-cell :border="false">
                                <div style="display: flex;flex-direction: row;justify-content:space-between;">
                                    <span style="font-size: 12px">数量</span>
                                    <van-stepper v-model="skuNum"/>
                                </div>
                            </van-cell>
                        </van-cell-group>
                    </div>
                </div>
            </div>
            <div class="d-btn">
                <van-button size="large" class="spec-btn1" @click="addCart" style="background-color: #F18AA2"
                            v-if="showType=='GWC'">加入购物车
                </van-button>
                <van-button size="large" class="spec-btn" @click="addCart" style="background-color: #F18AA2"
                            v-if="showType=='GM'">加入购物车
                </van-button>
                <van-button size="large" class="spec-btn" @click="setSku" style="background-color: #F04569"
                            v-if="showType=='GM'">立即购买
                </van-button>
            </div>
        </van-popup>
        <div id="box" class="box">
            <transition name="mybox" mode="out-in">
                <div class="caidan" v-show="boxshow">
                    <div style="padding-top: 8px" v-if="boxshow">
                        <div class="caidan-btn" @click="toHome">
                            <i class="el-icon-s-home"></i>
                            <span>首页</span>
                        </div>
                        <div class="caidan-btn" @click="toMy">
                            <i class="el-icon-user"></i>
                            <span>个人</span>
                        </div>
                        <div class="caidan-btn" @click="toPoster(spu,sku)">
                            <i class="el-icon-news"></i>
                            <span>海报</span>
                        </div>
                    </div>
                    <div class="cha">
                        <i @click="togglebox" class="el-icon-close">
                        </i>
                    </div>
                </div>
            </transition>
            <div class="box-btn" @click="togglebox">
                <i class="el-icon-arrow-up" style="font-size: 20px;margin-top: -5px;color: #92949A"></i>
                <p style="font-size: 10px;color: #92949A">导航</p>
            </div>
        </div>
        <van-popup v-model="showPoster">
            <div id="imageWrapper1">
                <div class="content_container">
                    <vue-canvas-poster v-if="!posterImg" :widthPixels="900" :heightPixels="1600"
                                       :painting="painting"
                                       @success="success" @fail="fail">
                    </vue-canvas-poster>
                    <van-image :src="posterImg" id="mypic" class="hb-img" crossOrigin="anonymous"/>
                </div>
            </div>
            <!--      <div style="background-color:#484848;opacity:1;display: block;">-->
            <!--        <van-button type="danger" style="width: 100%;height: 38px;line-height: 38px" @click="toSaveImage(posterImg)">保存图片</van-button>-->
            <!--      </div>-->
        </van-popup>
    </div>
</template>

<script>
    let adsId;
    let skuNum;
    let skuId;
    import {getCookie, getDeptId, getDeptName, setYqUrl} from "../../utils/auth";

    export default {
        data() {
            return {
                title: "详情",
                notice: '请在微信客户端打开链接!',
                isWeixin: true,
                appId: '',
                deptId: '',
                mid: '',
                spuId: '',
                spu: {},
                sku: {},
                skuId: '',
                skus: [],
                imgList: [],

                chosenCoupon: -1,
                coupons: [],
                showList: false,

                showBase: true,
                showType: '',

                show: false,
                skuNum: 1,

                specActive: 0,
                adsId: '',
                addressInfo: {},
                screenWidth: '',
                boxshow: false,

                currentTab: 'goods', // 当前选中的标签
                scrollTop: 0,
                opacity: 0,
                active: 'goods',

                showPoster: false,
                posterImg: '',//生成的海报
                painting: {
                    views: []
                }
            };
        },
        beforeRouteEnter(to, from, next) {
            skuNum = from.params.hasOwnProperty('skuNum') ? from.params.skuNum : ''
            skuId = from.params.hasOwnProperty('skuId') ? from.params.skuId : ''
            next();
        },
        async created() {
            document.title = getDeptName()
            this.screenWidth = window.innerWidth;
            this.spuId = this.$route.params.spuId
            this.mid = this.$route.params.mid
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
            await this.panduan()
            if (this.isWeixin) {
                if (!this.token) {
                    setYqUrl('/fxSpuDetails/' + this.deptId + '/' + this.mid + '/' + this.spuId)
                    this.$router.push('/invite/' + this.deptId + '/' + this.mid)
                }
            }
            await this.getSpmSpu()
            if (skuNum) {
                this.skuNum = skuNum
            }
            // if (skuId) {
            //   this.skuId = skuId
            // }
            // this.getAddress()
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop < 200) {
                    // 当滚动距离小于200时，计算导航透明度，可以考虑修改为每20增加0.1
                    // this.opacity = (scrollTop / 200).toFixed(1);
                    this.opacity = scrollTop / 200;
                    this.active = 'goods';
                    return
                } else {
                    this.opacity = 1
                }
                // 当滚动距离不小于200时，获取三个部分的顶部位置-45。
                let conTop = this.$refs.con.offsetTop - 500;
                let miaoshuTop = this.$refs.miaoshu.offsetTop - 500;
                let wypjTop = this.$refs.wypj.offsetTop - 300;
                // 计算滚动距离在哪个区间，修改this.active对应的样式名
                if (scrollTop) {
                    if (scrollTop == this.screenHeight) {
                        if (this.currentTab != 'wypj') this.currentTab = 'wypj';
                        return;
                    }
                    if (scrollTop < conTop) {
                        if (this.currentTab != 'goods') this.currentTab = 'goods';
                    }
                        // else if (scrollTop >= conTop && scrollTop < miaoshuTop) {
                        //     if (this.currentTab != 'con') this.currentTab = 'con';
                    // }
                    else if (scrollTop >= miaoshuTop && scrollTop < wypjTop) {
                        if (this.currentTab != 'miaoshu') this.currentTab = 'miaoshu';
                    } else if (scrollTop >= wypjTop) {
                        if (this.currentTab != 'wypj') this.currentTab = 'wypj';
                    }
                }
            },

            // 点击导航栏第一个商品选项卡时，直接滚动到0
            onScrollGoods() {
                window.scrollTo({top: 0, behavior: "smooth"});
            },
            // // 点击导航栏其他选项卡时，直接滚动到对应ref的offsetTop-45(导航栏高度)
            // onScrollCon() {
            //     if (!this.opacity) return;
            //     window.scrollTo({top: this.$refs.con.offsetTop - 45, behavior: "smooth"});
            // },
            onScrollMiaoshu() {
                if (!this.opacity) return;
                window.scrollTo({top: this.$refs.miaoshu.offsetTop - 45, behavior: "smooth"});
            },
            onScrollWypj() {
                if (!this.opacity) return;
                //document.documentElement.scrollTop = this.$refs.detail.offsetTop - 45;
                // behavior  类型String,表示滚动行为,支持参数 smooth(平滑滚动),instant(瞬间滚动),默认值auto,实测效果等同于instant
                window.scrollTo({top: this.$refs.wypj.offsetTop - 45, behavior: "smooth"});

            },

            panduan() {
                let that = this;
                var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
                var isWeixin = ua.indexOf("micromessenger") != -1; //判断是否
                this.isWeixin = isWeixin
                if (!isWeixin) {
                    return false;
                }
            },
            toHome() {
                this.$router.push('/home/' + this.deptId)
            },
            toMy() {
                this.$router.push('/my/' + this.deptId)
            },
            togglebox() {
                this.boxshow = !this.boxshow;
            },
            toCart() {
                this.$router.push('/cart/' + this.deptId)
            },
            async addCart() {
                let data = {
                    token: this.token,
                    skuId: this.sku.id,
                    skuNum: this.skuNum,
                    cartType: "1",
                    selected: true,
                }
                let res = await this.$post("/spm/addSpmCart", data)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }

            },
            onClickIcon() {

            },
            onClickLeft() {
                this.$router.push('/home/' + this.deptId)
            },

            // async getAddress() {
            //   let data = {
            //     adsId: this.adsId
            //   }
            //   let res = await this.$get("/spm/getSpmAddressInfo", data)
            //   this.addressInfo = res.info
            // },

            toSpec(showType) {
                this.show = true
                this.showType = showType
                this.skus.forEach((item, index) => {
                    if (item.id == this.sku.id) {
                        this.specActive = index;
                        return;
                    }
                })
                this.sku = this.sku
            },

            checkedSpec(index, sku) {
                this.specActive = index
                this.sku = sku
            },

            setSku() {
                this.show = false
                this.toBuy()
            },

            toBuy() {
                if (!getCookie('spmToken')) {
                    this.$router.push('/empower/' + this.deptId)
                    return;
                }
                this.$router.push('/buy/' + this.deptId + '/' + this.sku.id + '/' + this.skuNum)
            },

            //选择地址
            toAddress() {
                this.$router.push('/address/' + this.deptId)
            },

            async getSpmSpu() {
                let res = await this.$get("/spm/getSpmSpu", {spuId: this.spuId})
                this.spu = res.spu
                this.imgList = res.imgList
                if (res.skuList.length > 0) {
                    this.skus = res.skuList
                    if (this.skuId) {
                        res.skuList.forEach(item => {
                            if (this.skuId == item.id) {
                                this.sku = item
                                return;
                            }
                        })
                    } else {
                        this.sku = res.skuList[0]
                    }
                }
            },

            async toPoster(item, sku) {
                this.showPoster = true
                let data = {
                    token: this.token,
                    imgUrl: item.coverImg,
                    route: 'fxSpuDetails',
                    id: item.id,
                }
                let res = await this.$post("/spm/getSpmGoodsPoster", data)
                let imgUrl = res.imgUrl
                let touxiang = res.headPortrait
                if (!touxiang) {
                    if (res.member.sex == 2) {
                        touxiang = require('./../../assets/nv.png')
                    } else {
                        touxiang = require('./../../assets/nan.png')
                    }
                }
                var sellingPrice = '0'
                if (sku.sellingPrice) {
                    sellingPrice = sku.sellingPrice.toString()
                }
                var costPrice = '¥0'
                if (sku.costPrice) {
                    costPrice = '¥' + sku.costPrice.toString()
                }
                var spuName = ''
                if (item.spuName) {
                    spuName = item.spuName
                }
                console.log(item)
                this.painting = {
                    position: 'relative',
                    width: '900px',
                    height: '1600px',
                    background: '#FFFFFF',
                    views: [
                        {
                            type: 'image',
                            url: imgUrl,
                            css: {
                                position: 'absolute',
                                top: '0%',
                                color: '#000',
                                background: '#fff',
                                width: '900px',
                                height: '900px',
                                borderWidth: '40px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: 'image',
                            url: res.qrCode,
                            css: {
                                position: 'absolute',
                                right: '10%',
                                top: '63.7%',
                                color: '#000',
                                background: '#fff',
                                width: '210px',
                                height: '210px',
                                borderWidth: '20px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: "text",
                            text: "- 长按识别查看 -",
                            css: {
                                top: "77%",
                                right: '5%',
                                width: "300px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "25px",
                                color: "#D3D3D3",
                            },
                        },
                        {
                            type: 'image',
                            url: touxiang,
                            css: {
                                position: 'absolute',
                                top: '89%',
                                left: '55%',
                                color: '#000',
                                background: '#fff',
                                width: '98px',
                                height: '98px',
                                borderRadius: '60px',
                            },
                        },
                        {
                            type: "text",
                            text: res.member.memberName,
                            css: {
                                top: "89.5%",
                                left: "67%",
                                width: "250px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "36px",
                                color: "#555555",
                            },
                        },
                        {
                            type: "text",
                            text: "推荐一个好物给你",
                            css: {
                                top: "92.5%",
                                left: "67%",
                                height: "30px",
                                padding: "5px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "28px",
                                color: "#8B8A8A",
                            },
                        },
                        {
                            type: "text",
                            text: '¥',
                            css: {
                                top: "65.5%",
                                left: "8%",
                                width: "100px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "45px",
                                color: "#EE1111",
                            },
                        },
                        {
                            type: "text",
                            text: sellingPrice,
                            css: {
                                top: "64%",
                                left: "11.5%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "68px",
                                color: "#EE1111",
                            },
                        },
                        {
                            type: "text",
                            text: costPrice,
                            css: {
                                top: "69.5%",
                                left: "8%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "35px",
                                color: "#999999",
                                textDecoration: 'line-through',
                            },
                        },
                        {
                            type: "text",
                            text: spuName,
                            css: {
                                top: "73%",
                                left: "8%",
                                width: "500px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "45px",
                                color: "#5E5E5E",
                            },
                        },
                        {
                            type: "text",
                            text: 'PLUS会员',
                            css: {
                                top: "66%",
                                left: "31%",
                                height: "30px",
                                lineHeight: "30px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "25px",
                                color: "#ffffff",
                                background: '#3C251D',
                                padding: '5px',
                            },
                        },
                        {
                            type: "text",
                            text: '既省钱又省心',
                            css: {
                                top: "66%",
                                left: "45%",
                                height: "30px",
                                lineHeight: "30px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "25px",
                                color: "#5E5E5E",
                                padding: '5px',
                            },
                        },
                        {
                            type: 'image',
                            url: require('./../../assets/md.png'),
                            css: {
                                position: 'absolute',
                                top: '90%',
                                left: '8%',
                                color: '#000',
                                background: '#fff',
                                width: '58px',
                                height: '58px',
                            },
                        },
                        {
                            type: "text",
                            text: res.deptName,
                            css: {
                                top: "90%",
                                left: "13%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "45px",
                                color: "#8B8A8A",
                            },
                        },

                    ],
                }
            },


            // 保存图片到本地
            toSaveImage(img) {
            },

            // 海报生成
            success(src) {
                this.posterImg = src
            },
            fail() {

            },

            //赋值
            handleUpdateBg(row) {
                this.posterImg = ''
                this.painting.views[0].url = row.qrUrl
            },
        },
    };
</script>

<style lang="scss" scoped>
    .spxqy {
        overflow: scroll;
    }

    .nav {
        height: 45px;
        width: 100%;
        background-color: #fff;
        position: fixed;
        z-index: 99;
        opacity: 999;
    }

    .detail_anchor {
        width: 100%;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #666;
        box-shadow: 0 1px 6px rgba(0, 0, 0, .1);
        justify-content: space-evenly;
    }

    .header-new-title {
        height: 44px;
        font-size: 16px;
        line-height: 44px;
        text-align: center;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        flex-direction: row;
        width: 80%;
        margin: auto;
    }

    .dhbt {
        width: 25%;
    }

    .active1 {
        color: #e4393c;
    }

    .wypj {
        padding-bottom: 50px;
    }

    .goods-img {
        width: 100%;
        display: block;
    }

    .goods-message .van-cell__title {
        font-size: 16px;
    }

    .goods-message .van-cell__label {
        color: #f44;
    }

    .goods-express {
        color: #999;
        font-size: 12px;
    }

    .goods-express .van-cell {
        color: #999;
        font-size: 12px;
        padding: 5px 15px;
    }

    .goods-express .van-col {
        text-align: left;
    }

    .goods-cell-group {
        margin: 0 0;
    }

    .goods-cell-group .van-cell__value {
        color: #999;
    }

    .goods-tag {
        margin-left: 5px;
    }

    .goods-action {
        position: relative !important;
    }

    .jg-span {
        height: 20px;
        margin-left: 8px;
        font-size: 10px;
        text-decoration: line-through;
        color: #888888
    }

    .tab-titel {
        font-size: 12px;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }

    .specs {
        width: 95%;
        margin: auto;
        padding-top: 40px;
        height: 100%;
        overflow: hidden;
    }

    .sku-info {
        border-bottom: #BBBBBB solid 1px;
        padding-bottom: 5px;
        display: flex;
        flex-direction: row;
    }

    .sku-info img {
        width: 50px;
        height: 50px;
    }

    .sku-spec {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        padding: 10px 5px;
        height: 100%;
        overflow: auto;
        padding-bottom: 65px;
    }

    .spm-item {
        display: flex;
        flex-flow: row wrap;
        margin-top: 12px;
    }

    .spm-item-spec {
        box-sizing: border-box;
        height: 20px;
        line-height: 16px;
        margin: 4px;
        padding: 2px 16px;
        font-size: 12px;
        /*margin-bottom: 8px;*/
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background-color: #E8E8E8;
        border-radius: 5px;
        /*width: calc((100% - 60px) / 4); // 我这里一行显示4个 所以是/4  一行显示几个就除以几*/
        /*min-width: calc((100% - 60px) / 4);*/
        /*max-width: calc((100% - 60px) / 4);*/

        /*&:nth-child(4n + 4) {*/
        /*  margin-right: 0;*/
        /*}*/
    }

    .spec-active {
        background-color: #F799AA;
    }

    .spec-btn {
        font-size: 15px;
        width: 50%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }
    .spec-btn1 {
        font-size: 15px;
        width: 100%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }

    .d-btn {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 0px;
        background-color: #FFFFFF;
        height: 38px;
    }

    .sq-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 23%;
    }

    .weui-msg {
        padding-top: 36px;
        text-align: center;
    }

    .weui-msg__icon-area {
        margin-bottom: 30px;
    }

    .weui-icon_msg {
        font-size: 93px;
    }

    .weui-icon-info {
        font-size: 23px;
        color: #10aeff;
    }

    .weui-msg__text-area {
        margin-bottom: 25px;
        padding: 0 20px;
    }

    .weui-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 20px;
    }

    .weui_msg__desc {
        margin-top: 16px;
    }

    .hb-img {
        width: 278px;
        height: 500px;
        background-size: 100% 100%;
    }
</style>
